import React, { useState, useEffect } from "react";
import { Box, Typography, TextField, Button, Container, Link } from "@mui/material";

const TrackOrder = () => {
  useEffect(() => {
    // Load 17TRACK External Call Script
    const script = document.createElement("script");
    script.src = "//www.17track.net/externalcall.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const [orderNumber, setOrderNumber] = useState("");
  const [email, setEmail] = useState("");
  const [orderError, setOrderError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [globalError, setGlobalError] = useState(false);

  const handleTrack = () => {
    let hasEmpty = false;
    
    // Reset errors
    setOrderError("");
    setEmailError("");
    setGlobalError(false);

    if (!orderNumber) {
      setOrderError("Please enter an order number.");
      hasEmpty = true;
    }

    if (!email) {
      setEmailError("Please enter an email address.");
      hasEmpty = true;
    }

    if (hasEmpty) {
      return;
    }

    // Trigger 17TRACK tracking
    if (window.YQV5) {
      window.YQV5.trackSingle({
        YQ_ContainerId: "YQContainer",
        YQ_Height: 600,
        YQ_Fc: "0",
        YQ_Lang: "en",
        YQ_Num: orderNumber
      });
    } else {
      // Fallback if script not loaded yet
      window.open(`https://www.17track.net/en/track?nums=${encodeURIComponent(orderNumber)}`, "_blank");
    }
  };

  return (
    <Box sx={{ mt: "220px" }}>
      {globalError && (
        <Box
          sx={{
            backgroundColor: "#fdecea",
            color: "#d32f2f",
            px: 3,
            py: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1.5,
            fontSize: "14px",
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#d32f2f",
              color: "#fff",
              borderRadius: "50%",
              width: "18px",
              height: "18px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
              fontWeight: 700,
            }}
          >
            !
          </Box>
          <Typography sx={{ fontSize: "inherit", fontWeight: 500 }}>
            We're sorry, we couldn't find your order. Please try re-entering your information. You can find your order number in your order confirmation email.{" "}
            <Link
              component="button"
              onClick={() => setGlobalError(false)}
              sx={{
                color: "inherit",
                textDecoration: "underline",
                fontSize: "inherit",
                border: "none",
                background: "none",
                cursor: "pointer",
                p: 0,
                mt: -0.5
              }}
            >
              Dismiss
            </Link>
          </Typography>
        </Box>
      )}

      <Container maxWidth="sm" sx={{ mt: globalError ? "30px" : "60px", mb: "100px" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 500,
              fontFamily: "inherit",
              textAlign: "left",
              mb: 2,
            }}
          >
            Track your order
          </Typography>

          <TextField
            fullWidth
            label="Order Number (from order confirmation email)*"
            variant="outlined"
            value={orderNumber}
            error={!!orderError}
            helperText={orderError}
            onChange={(e) => {
              const val = e.target.value;
              if (val.includes("@")) {
                setOrderError("Order number cannot be an email address.");
              } else {
                setOrderNumber(val);
                if (val) setOrderError("");
              }
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
              },
              "& .MuiFormHelperText-root": {
                marginLeft: 0,
                marginTop: "8px",
                color: "#d32f2f"
              }
            }}
          />

          <TextField
            fullWidth
            label="Email*"
            variant="outlined"
            value={email}
            error={!!emailError}
            helperText={emailError}
            onChange={(e) => {
              setEmail(e.target.value);
              if (e.target.value) setEmailError("");
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
              },
              "& .MuiFormHelperText-root": {
                marginLeft: 0,
                marginTop: "8px",
                color: "#d32f2f"
              }
            }}
          />

          <Button
            fullWidth
            variant="contained"
            onClick={handleTrack}
            sx={{
              backgroundColor: "#000",
              color: "#fff",
              borderRadius: 0,
              py: 1.5,
              fontSize: "1rem",
              fontWeight: 700,
              textTransform: "capitalize",
              "&:hover": {
                backgroundColor: "#333",
              },
            }}
          >
            Check order status
          </Button>

          <Link
            href="/privacy"
            sx={{
              color: "#666",
              fontSize: "14px",
              textDecoration: "underline",
              textAlign: "left",
              display: "inline-block",
              mt: 1,
              "&:hover": {
                color: "#000",
              },
            }}
          >
            Privacy Policy
          </Link>
        </Box>
        
        {/* 17TRACK Result Container */}
        <Box id="YQContainer" sx={{ mt: 5 }}></Box>
      </Container>
    </Box>
  );
};

export default TrackOrder;
